import React from 'react';
import { StarIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, testimonials } from '../data/content';
export function Testimonials() {
  return <section aria-labelledby="testimonios" className="bg-pitch" data-id="element-170" data-mp="3fycoti6qzx8o">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-171" data-mp="3b146nhllnt7f">
        <h2 id="testimonios" className="font-display text-[1.8rem] font-normal uppercase leading-[1.05] text-white sm:text-5xl" data-id="element-172" data-mp="3ayqb77n0cezc">
          Lo que dicen{' '}
          <span className="text-gold" data-id="element-173" data-mp="321zb8k5c4fzh">quienes ya empezaron</span>
        </h2>
        <p className="mx-auto mt-1 max-w-xl text-sm leading-snug text-white/85" data-id="element-174" data-mp="2x1bj1v5ddt3o">
          De no saber cómo organizar una práctica a comprender cómo preparar
          entrenamientos de fútbol paso a paso.
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-175" data-mp="v7c8xd3zhhsk">
          {testimonials.map((t, i) => <Reveal key={t.author} as="li" delay={i * 0.03} className={`flex h-full flex-col rounded-xl border-2 border-gold bg-white p-2.5 text-left text-pitch ${i === testimonials.length - 1 ? 'sm:col-span-2' : ''}`} data-id="element-176" data-mp="q8933qg6j7jj" data-mpi={i}>
              <div className="flex items-center justify-between gap-2" data-id="element-177" data-mp="c6vfbri34vbh">
                <span className="font-sub text-xs font-extrabold text-field" data-id="element-178" data-mp="c8y0ny8am09v">
                  TESTIMONIO {i + 1}
                </span>
                <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-179" data-mp="14v99fw61z7hr">
                  {Array.from({
                length: 5
              }).map((_, j) => <StarIcon key={j} size={13} className="fill-gold text-gold" data-id="element-180" data-mp="q63fonpzi9h9" data-mpi={j} />)}
                </div>
              </div>
              <blockquote className="mt-1 text-xs italic leading-snug sm:text-sm" data-id="element-181" data-mp="1ith41xfm9wpr">
                “{t.quote}”
              </blockquote>
              <div className="mt-auto pt-1.5" data-id="element-182" data-mp="1xiipsomnt6f0">
                <p className="font-sub text-sm font-extrabold text-pitch" data-id="element-183" data-mp="1xh7msr11g2oy">
                  {t.author}
                </p>
                <p className="text-xs leading-snug text-pitch/75" data-id="element-184" data-mp="1ohavsir6erqq">
                  {t.role} · {t.location}
                </p>
              </div>
            </Reveal>)}
        </ul>

        <CtaButton href={OFFER_ANCHOR} className="mt-4" data-id="element-185" data-mp="1jkkdrpvt9m2o">
          🚀 Sí, quiero comenzar ahora
        </CtaButton>
        <p className="mt-2.5 text-xs font-semibold text-white/80" data-id="element-186" data-mp="19sog2fxmzxyz">
          Acceso Inmediato • Garantía de 7 Días
        </p>
      </div>
    </section>;
}